module.exports = __webpack_public_path__ + "static/12-fe2d334475288636022882fecfdd377e.jpg";